<template>
  <card>
    <list
      title_add="Начать импорт"
      title_add_key="start_import"
      v-if="$store.state.user.sections['imports']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :params="params"
      :filters="filters"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      filters: [],
      params: {},
      val: [],
      modalCreate: "import",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "model",
          label: "Тип  документа",
          type: "static_radio",
          items: [
            { id: "import", title: "import" },
            { id: "transfer", title: "transfer" },
            { id: "user", title: "user" },
            { id: "email", title: "email" },
            { id: "word", title: "word" },
            { id: "imei", title: "imei" },
            { id: "imei-status", title: "imei-status" },
          ],
        },
        {
          col: " col-12 col-md-12",
          key: "file",
          label: "EXCEL документ",
          type: "zip",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "imports",
      setLink: "imports",
      columns: [
        {
          key: "id",

          title: "Номер импорта",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "user",
          object: "name",
          title: "Отвественный",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "shop",
          object: "name",
          title: "Магазин",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "model",
          title: "Тип документа",
          checkbox: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "file",
          title: "Файл",
          checkbox: false,
          control: false,
          link: true,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Дата",
          checkbox: false,
          control: false,
          dateTimeFormat: true,
          align: "left",
          timer: false,
          detail: false,
        },
      ],
    };
  },
};
</script>
<style>
</style>
